import {Component, OnInit} from '@angular/core';
import {AppComponent} from "../app.component";
import {renderNode} from "@angular/core/src/view/util";
declare var jQuery: any;

@Component({
    selector: 'app-evento-list',
    templateUrl: './evento-list.component.html',
    styleUrls: ['./evento-list.component.css']
})
export class EventoListComponent extends AppComponent implements OnInit {
    dados: any;
    value:string;


    ngOnInit() {
        if (!this.isAdmin())
            this.router.navigateByUrl('inicio');
		else
			this.eventoService.search("").then((resp) => this.dados = (resp));

    }

    search() {
        let data = new Object();
        data['value'] = this.value;
        this.eventoService.search(data).then((resp) => this.dados = (resp));
    }



}



// WEBPACK FOOTER //
// ./src/app/evento-list/evento-list.component.ts